enum quickLinksItemTestIds {
	quickLink = 'quick-link',
	itemDesc = 'item-desc',
}

export default quickLinksItemTestIds;
